import { Directive, HostListener, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appPreventSpecialChars]',  // Apply this directive with `appPreventSpecialChars`
})
export class PreventSpecialCharsDirective {
  @Input() forbiddenChars: string[] = ['<', '>', '"', "'", '/', '%','@'];  // Default forbidden characters

  constructor() {}

  // Listen for the 'input' event on any element where this directive is applied
  @HostListener('input', ['$event']) onInputChange(event: any): void {
    const input = event.target;
    const forbiddenPattern = new RegExp(`[${this.forbiddenChars.join('')}]`, 'g');
    
    // Remove forbidden characters from the input value
    input.value = input.value.replace(forbiddenPattern, '');
  }

  // Optionally: Prevent forbidden keys from being pressed (prevent entry)
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    if (this.forbiddenChars.includes(event.key)) {
      event.preventDefault();  // Prevent the forbidden character from being typed
    }
  }
}

